import { MatIconModule } from '@angular/material/icon'
import { CommonModule, Location } from '@angular/common'
import { Component, inject, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { RouterOutlet } from '@angular/router'
import { AbstractComponent } from '@monorepo-channels/channels/domain'
import { DataLayerService, MenuOpened } from '@monorepo-channels/shared/util-helpers'

@Component({
	standalone: true,
	imports: [CommonModule, MatButtonModule, RouterOutlet, MatIconModule],
	templateUrl: './how-it-works.page.html',
	styleUrl: './how-it-works.page.scss',
})
export class HowItWorksPageComponent extends AbstractComponent implements OnInit {
	steps = [
		{
			id: 1,
			title: 'Cadastre-se ou faça Login no Gastronomia Porto Bank',
			content:
				'Com o seu cartão de crédito Porto Bank e comece a aproveitar diferenciais especiais em uma seleção de restaurantes conceituados',
		},
		{
			id: 2,
			title: 'Explore os restaurantes participantes',
			content: 'Entre em "Ver restaurante" e escolha entre os diversos tipos de culinárias',
		},
		{
			id: 3,
			title: 'Faça uma reserva ou check-in ',
			content:
				'Acesse a página de detalhes do restaurante, selecionando data, horário e ambiente desejados.',
		},
		{
			id: 4,
			title: 'Aproveite seus benefícios no restaurante escolhido',
			content: 'Pague a conta com seu cartão de crédito Porto Bank e usufrua dos benefícios',
		},
	]

	public menuOpened = inject(MenuOpened)
	public location = inject(Location)
	private dataLayerService = inject(DataLayerService)

	ngOnInit(): void {
		this.dataLayerService.logEvent({
			event: 'screen_view',
			screen_name: 'Gastronomia Porto Bank - Como funcionna',
		})
	}
}
